import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import { PluginContext } from '../../../contexts';

import {
   Card,
   CardContent,
   Container,
   Grid,
   Typography,
   Button,
   IconButton,
   Divider,
   colors
} from '@material-ui/core';

import {
   Alert,
   AlertTitle
} from '@material-ui/lab';

import {
   FieldError,
   UploadFile
} from '../../../common';

import {
   Form,
   Formik,
   Field
} from 'formik';

import {
   TextField,
   CheckboxWithLabel
} from 'formik-material-ui';

import {
   GoogleCertificatesWizard
} from './Wizards';

import { PageContext } from '../PageContext';
import { ToastContext } from '../../../contexts/ToastContext';

import { FileType, MaxFileSize, getColoredBottonStyle } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DeleteIcon from '@material-ui/icons/Delete';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
   root: {
   },
   title: {
      fontSize: "1.2em"
   },
   content: {
      marginTop: theme.spacing(4)
   },
   field: {
      width: "100%"
   },
   progress: {
      color: "black"
   },
   pickerBox: {
      marginLeft: "-6px"
   },
   deleteButton: {
      //...getColoredBottonStyle(theme, colors.red)
      color: colors.red[500],
      marginLeft: theme.spacing(2)
   },
   resetButton: {
      ...getColoredBottonStyle(theme, colors.red)
   },
   helpMeButton: {
      ...getColoredBottonStyle(theme, colors.orange)
   },
   wizard: {
      marginTop: theme.spacing(2)
   }
}));

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
   _wpApAdminSettings = window['wpApAdminSettings'];
}

export const AndroidForm = ({
   formRef,
   errors,
   validationSchema,
   disabled,
   upload,
   createCerts,
   onBlur,
   onSubmit,
   ...props }) => {
   const classes = useStyles();

   const { t, i18n } = useTranslation();

   const {
      state,
      mergeSettings
   } = useContext(PageContext);

   const {
      showSuccessMessage,
      showWarningMessage
   } = useContext(ToastContext);

   const {
      settings
   } = state;

   const uploadFileAsync = async (fileType, data, file, credentials) => {
      if (upload) {
         const storedFileInfo = await upload(fileType, data, file, credentials);
         if (storedFileInfo !== null) {
            switch (fileType) {
               case FileType.AndroidKeyStore:
                  mergeSettings({ androidKeyStoreFile: storedFileInfo.publicUrl });
                  showSuccessMessage(t("MessageFileUploadOk"));
                  break;
               default:
                  break;
            }
            return true;
         } else {
            return false;
         }
      }
      else {
         return false;
      }
   }

   const getInitialValues = () => {
      return {
         enableAndroidBuild: settings.enableAndroidBuild ? settings.enableAndroidBuild : false,
         androidKeyStoreFile: settings.androidKeyStoreFile ? settings.androidKeyStoreFile : "",
         androidKeyStoreAlias: settings.androidKeyStoreAlias ? settings.androidKeyStoreAlias : "",
         androidKeyStorePassword: settings.androidKeyStorePassword ? settings.androidKeyStorePassword : "",
      };
   }

   const fileDropHandler = (fileType, file) => {
      let isFileOk = false;
      let wrongFileMessage = null
      if (file.size <= MaxFileSize.Max5MB) {
         switch (fileType) {
            case FileType.AndroidKeyStore:
               isFileOk = file.name.includes(".keystore");
               wrongFileMessage = t("MessageAndroidInvalidKSFile");
               break;
            default:
               return false;
         }
      } else {
         showWarningMessage(t("MessageWrongFileSize5"));
         return false;
      }

      if (isFileOk) {
         return true;
      } else {
         showWarningMessage(wrongFileMessage);
         return false;
      }

   }

   const submitClickHandler = (values, actions) => {
      if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
   }

   const resetValuesHandler = () => {
      mergeSettings({
         androidKeyStoreAlias: "",
         androidKeyStorePassword: "",
         androidKeyStoreFile: ""
      });
   }

   const [inWizard, setInWizard] = useState(false);
   const startWizardClickHandler = () => {
      setInWizard(true);
   }

   const wizardCompletedHandler = async (keystoreAlias, email, bundleId) => {
      if (createCerts) {
         const certsInfo = await createCerts(keystoreAlias, email, bundleId);
         if (certsInfo) {
            setInWizard(false);
            mergeSettings({
               androidKeyStoreAlias: certsInfo.keystoreAlias,
               androidKeyStorePassword: certsInfo.keystorePassword,
               androidKeyStoreFile: certsInfo.keystorePublicUrl,
            });
         }
      }
   }

   const [isConfigured, setIsConfigured] = useState(false);
   useEffect(() => {
      setIsConfigured(
         //    settings.androidKeyStoreAlias && 
         settings.androidKeyStorePassword
         && settings.androidKeyStoreFile
      );
   }, [settings]);

   const {
      getAssetUrl
   } = useContext(PluginContext);

   return (
      <Card className={clsx(classes.root, props.className)}>
         <CardContent>
            <Container maxWidth="lg" className={classes.content}>
               <Formik
                  enableReinitialize
                  initialValues={getInitialValues()}
                  onSubmit={submitClickHandler}
                  innerRef={formRef}
                  validationSchema={validationSchema}
                  validateOnChange={false}
                  validateOnBlur={true}
                  validate={(values) => {
                     if (onBlur) onBlur(values);
                  }}>
                  {(props) => {
                     const {
                        values,
                        isSubmitting,
                        handleSubmit,
                        setFieldValue
                     } = props;
                     return (
                        <Form noValidate autoComplete="off">
                           <Grid container spacing={3}>
                              <Grid container item xs={12} alignContent="center" justify="space-between">
                                 <div>
                                    <Field
                                       type="checkbox"
                                       name="enableAndroidBuild"
                                       component={CheckboxWithLabel}
                                       Label={{ label: t("LabelAndroidBuildEnabled") }}
                                       disabled={disabled}
                                    />
                                    <FieldError
                                       name="enableAndroidBuild"
                                       errors={errors}
                                    />
                                 </div>

                                 <Button
                                    className={classes.helpMeButton}
                                    onClick={() => window.open(getAssetUrl(t("LabelAndroidBuildHelpUrl")))}>
                                    {t("LabelHints")}
                                 </Button>

                                 <Button
                                    className={classes.resetButton}
                                    disabled={!values.enableAndroidBuild || !isConfigured || disabled}
                                    onClick={() => resetValuesHandler()}>
                                    {t("ButtonResetCertificates")}
                                 </Button>
                              </Grid>
                              {false && values.enableAndroidBuild &&
                                 <>
                                    <Grid item xs={12}>
                                       <Divider />
                                    </Grid>
                                    <Grid item xs={12}>
                                       {inWizard ?
                                          <>
                                             {settings.bundleId ?
                                                <>
                                                   <Alert severity="info" variant="outlined">
                                                      <span
                                                         dangerouslySetInnerHTML={{ __html: t("LabelAndroidCertWizardWizardHint") }}
                                                      />
                                                   </Alert>
                                                   <GoogleCertificatesWizard
                                                      className={classes.wizard}
                                                      upload={upload}
                                                      disabled={!values.enableAndroidBuild || disabled}
                                                      onWizardCanceled={() => setInWizard(false)}
                                                      onWizardComplete={wizardCompletedHandler}
                                                   />
                                                </>
                                                :
                                                <Alert severity="warning" variant="outlined">
                                                   <span
                                                      dangerouslySetInnerHTML={{ __html: t("LabelCertWizardBundleId") }}
                                                   />
                                                </Alert>
                                             }
                                          </>
                                          :
                                          <>
                                             {!isConfigured &&
                                                <Alert
                                                   severity="info"
                                                   variant="outlined">
                                                   <AlertTitle>
                                                      {t("LabelCertWizardHelpTitle")}
                                                   </AlertTitle>
                                                   <div
                                                      dangerouslySetInnerHTML={{ __html: t("LabelAndroidCertWizardHelpBody") }}
                                                   />
                                                   <Grid container justify="flex-end">
                                                      <Grid item>
                                                         <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disabled={!values.enableAndroidBuild || disabled}
                                                            onClick={startWizardClickHandler}>
                                                            {t("ButtonStartWizard")}
                                                         </Button>
                                                      </Grid>
                                                   </Grid>
                                                </Alert>
                                             }
                                          </>
                                       }
                                    </Grid>
                                 </>
                              }
                              {!inWizard &&
                                 <>
                                    {
                                       /*
                                       <Grid item xs={12}>
                                           <Field
                                               className={classes.field}
                                               name="androidKeyStoreAlias"
                                               type="text"
                                               variant="outlined"
                                               label={t("LabelAndroidKeyStoreAlias")}
                                               helperText={t("HelperAndroidKeyStoreAlias")}
                                               disabled={!values.enableAndroidBuild || values.androidKeyStoreFile !== "" || inWizard || disabled}
                                               component={TextField}
                                               inputProps={{
                                                   autoComplete: 'new-password',
                                                   form: {
                                                       autoComplete: 'off'
                                                   }
                                               }}
                                           />
                                           <FieldError
                                               name="androidKeyStoreAlias"
                                               errors={errors}
                                           />
                                       </Grid>
                                       */
                                    }
                                    <Grid item xs={12}>
                                       <Field
                                          className={classes.field}
                                          name="androidKeyStorePassword"
                                          type="password"
                                          variant="outlined"
                                          label={t("LabelAndroidKeyStorePassword")}
                                          helperText={t("HelperAndroidKeyStorePassword")}
                                          disabled={!values.enableAndroidBuild || values.androidKeyStoreFile !== "" || inWizard || disabled}
                                          component={TextField}
                                          inputProps={{
                                             autoComplete: 'new-password',
                                             form: {
                                                autoComplete: 'off'
                                             }
                                          }}
                                       />
                                       <FieldError
                                          name="androidKeyStorePassword"
                                          errors={errors}
                                       />
                                    </Grid>
                                    {values.androidKeyStoreFile ?
                                       <Grid container item xs={12} alignItems="center" justify="flex-start">
                                          <InsertDriveFileIcon fontSize="large" />
                                          <Typography>
                                             {`${FileType.AndroidKeyStore}.keystore`}
                                          </Typography>
                                          <IconButton
                                             className={classes.deleteButton}
                                             size="small"
                                             disabled={!values.enableAndroidBuild || inWizard || disabled}
                                             onClick={() => mergeSettings({ androidKeyStoreFile: "" })}>
                                             <DeleteIcon />
                                          </IconButton>
                                       </Grid>
                                       :
                                       <Grid item xs={12}>
                                          <UploadFile
                                             title={t('LabelAndroidKeyStoreFile')}
                                             singleFile
                                             onFileDrop={(files) => fileDropHandler(FileType.AndroidKeyStore, files[0])}
                                             disabled={!values.enableAndroidBuild || inWizard || disabled}
                                             upload={(data, file) => uploadFileAsync(
                                                FileType.AndroidKeyStore,
                                                data,
                                                file,
                                                { alias: values.androidKeyStoreAlias, password: values.androidKeyStorePassword }
                                             )}
                                             helpText={t("LabelUploadHelp")}
                                             uploadButtonText={t("LabelUploadFile")}
                                             removeButtonText={t("LabelRemoveFile")}
                                             removeAllButtonText={"LabelRemoveAllFiles"}
                                          />
                                          <FieldError
                                             name="androidKeyStoreFile"
                                             errors={errors}
                                          />
                                       </Grid>
                                    }
                                 </>
                              }
                           </Grid>
                        </Form>
                     );
                  }}
               </Formik>
            </Container>
         </CardContent>
      </Card>
   );
}